module.exports = __webpack_public_path__ + "static/media/sensor-fire.61392a9a.svg";